import _ from "lodash";

export const addCoupon = (state, action) => {
  let list = state.list;
  const savedCoupon = action.payload;

  return [savedCoupon, ...list];
};

export const updateCoupon = (state, action) => {
  let list = state.list;
  const updatedCoupon = action.payload;

  const index = _.findIndex(list, ["id", updatedCoupon.id]);
  list[index] = updatedCoupon;

  return [...list];
};

export const removeCoupon = (state, action) => {
  let list = state.list;
  const deletedCouponId = action.payload;

  const filteredList = _.filter(list, function (td) {
    return td.id !== deletedCouponId;
  });

  return [...filteredList];
};
export const formtValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};
